import { StudyEventDefinition } from './StudyEventDefinition';
import { StudyEventProcedure } from './StudyEventProcedure';
import { StudyProcedureDefinition } from './StudyProcedureDefinition';

export class StudyTable {
  constructor(params = {}) {
    this.studyProcedureDefinitions = params.studyProcedureDefinitions?.map((spd) => new StudyProcedureDefinition(spd));
    this.studyEventDefinitions = params.studyEventDefinitions?.map((sed) => new StudyEventDefinition(sed));
    this.studyEventProcedures = params.studyEventProcedures?.map((sep) => new StudyEventProcedure(sep));
    this.positions = params.positions;
  }
}

export default StudyTable;
